module.exports = __webpack_public_path__ + "img/pumpcharge.2952a731.png";